const callSerialize = (data) => (data.serialize ? data.serialize() : data);

/**
 * Convert `model` to a JSON-formatted string using
 * `JSON.stringify()`.
 *
 * If `model.serialize()` exists, call this method
 * and pass the result to `JSON.stringify()`.
 *
 * If `model` is an array, serialize each element of the array and
 * return a string containing a JSON array.
 *
 * @param {object} model - The object to transform to a JSON-formatted
 * string. If `model` is falsy, it is returned as is.
 * @param {function} [model.serialize] - Function to call to transform
 * `model` into key/value pairs. If absent, `model` is passed to
 * `JSON.stringify` directly.
 */
export default function serialize(model) {
	if (!model) {
		return model;
	}

	if (Array.isArray(model)) {
		return JSON.stringify(model.map(callSerialize));
	}

	return JSON.stringify(callSerialize(model));
}
